import type { FaireProductEntity } from "../../entity_types/product";

export const p_fedubjfrhu: FaireProductEntity = {
  token: "p_fedubjfrhu",
  type: "product",
  name: "SOAK Bomb",
  brandToken: "b_39kn6t66bv",
  brandName: "River Ridge Soaps",
  imageUrl:
    "https://cdn.faire.com/fastly/51f7b4dd99f31b35510ee723e0cb115547da31d03868028bc01186eb93c80a8b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/aba75448dd65781dd099d31e325d639a9ccd842dc9e9ebdf3e3b4587047dbff9.png",
    "https://cdn.faire.com/fastly/adbacd6c9053d2952c589057f0d8a0db8c5f73059870717f7b26182df3678155.jpeg",
    "https://cdn.faire.com/fastly/61cd414c92fd8d639e6da7381b81438262811145754fc2e112a0518d487b3256.jpeg",
    "https://cdn.faire.com/fastly/f1a9a887e39ca8d76e0c5be49d5f732e87f5c159f7ba9d24461152ba0f3d4610.jpeg",
    "https://cdn.faire.com/fastly/2530fd66197d6b0f2f325387370f7e084bfd0e2954abc34f5165509aeacd0e61.jpeg",
    "https://cdn.faire.com/fastly/9aa434554cda3a7829a6af095819ea69fe9ff0ef7ec5a09f7386b1f621116185.jpeg",
    "https://cdn.faire.com/fastly/a04ed9d9c451060c38f00c3f136f41b1fce11337651d859429e0332b53402bad.jpeg",
    "https://cdn.faire.com/fastly/87f796b28340b56c163e511c7a4f10ddf57dbf2207f11d2e394a7bee1703eea6.jpeg",
    "https://cdn.faire.com/fastly/fe0d93e30050fc441edcc36b53d2e314912c8cb682e5703ede3703d07c9100d0.jpeg",
  ],
  priceDollars: 5.5,
  description:
    "These SOAK bombs turn your bath into a spa!  This is not your child's bath bomb.  Fill your tub with buttermilk foam, aromatherapy scents, Cocoa, Mango and Babassu Butters and relax while your skin says thank you.  These are a luxury spa type experience.\n\nWatch video for fizzing action and buttermilk foam.\n\nTopped with colored sea salts and come in adorable silver foil printed gift box ready to sell with scent labeled on bottom. \n\nWill not color tub water or walls, will not leave residue.",
  tags: [],
  msrpDollars: 11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:20.599Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
